// extracted by mini-css-extract-plugin
export var allNePasManquer = "ne-pas-manquer-module--all-ne-pas-manquer--05a5f";
export var editButtonTitle = "ne-pas-manquer-module--edit-button-title--259bd";
export var nePasManquerContainer = "ne-pas-manquer-module--ne-pas-manquer-container--25b46";
export var nePasManquerItem = "ne-pas-manquer-module--ne-pas-manquer-item--fcc0b";
export var nePasManquerItemDescription = "ne-pas-manquer-module--ne-pas-manquer-item-description--7a2d4";
export var nePasManquerItemImg = "ne-pas-manquer-module--ne-pas-manquer-item-img--85227";
export var nePasManquerListItem = "ne-pas-manquer-module--ne-pas-manquer-list-item--7a657";
export var nePasManquerResume = "ne-pas-manquer-module--ne-pas-manquer-resume--c2829";
export var nePasManquerTitle = "ne-pas-manquer-module--ne-pas-manquer-title--17694";